import { CardContentBox } from "../../profile/components/CardElements"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { Divider, List, ListItemButton, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { MatchEnvironment } from "../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../environment/envTypes"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/pro-light-svg-icons"
import { useMatches, useNavigate } from "react-router-dom"
import { isObjectWithProp } from "../../../lib/lang"
import { getProfileChangePasswordRoute } from "../../../constants/routes"

const useStyles = makeStyles()((theme) => ({
    listItem: {
        padding: "1rem",
        justifyContent: "space-between",
    },
    textColor: {
        color: theme.palette.tailwind.gray[600],
    },
    iconColor: {
        color: theme.palette.tailwind.neutral[600],
    },
}))

export function UserPasswordCard() {
    const { classes } = useStyles()
    const navigate = useNavigate()
    const routeMatches = useMatches()
    const environmentRoutePath = routeMatches.find(
        (match) => isObjectWithProp(match.handle, "environmentRoot") && Boolean(match.handle.environmentRoot),
    )?.pathname

    const handleChangePassword = () => {
        navigate(getProfileChangePasswordRoute(environmentRoutePath))
    }

    return (
        <CardContentBox
            title={
                <LocalizedStrict id="profile-password-card">
                    <>Password</>
                </LocalizedStrict>
            }
        >
            <List>
                <Divider />
                <ListItemButton className={classes.listItem} onClick={handleChangePassword}>
                    <LocalizedStrict id="profile-actions-change-password">
                        <Typography variant="body1" className={classes.textColor}>
                            Change password
                        </Typography>
                    </LocalizedStrict>
                    <FontAwesomeIcon icon={faChevronRight} className={classes.iconColor} />
                </ListItemButton>
                <Divider />
            </List>
        </CardContentBox>
    )
}
